// src/componentes/Header.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import logocompleto from "../assets/img/FomexLogocompleto.png";
import useScrollDirection from "./useScrollDirection";
import { Icons } from "../assets/icons/icons";

const Header = () => {
  const navigate = useNavigate();
  const scrollDirection = useScrollDirection();
  const [isAtTop, setIsAtTop] = React.useState(true);

  // Determinar si el header debe estar oculto
  const isHidden = scrollDirection === "down" && !isAtTop;

  React.useEffect(() => {
    const handleScroll = () => {
      setIsAtTop(window.scrollY < 100); // Considerar "top" si está a menos de 100px
    };

    window.addEventListener("scroll", handleScroll);
    // Verificar posición inicial
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      // 1. Definir el OFFSET (la altura de tu header, 100px en este caso)
      const offset = 100;

      // 2. Calcular la posición del elemento, restándole el offset.
      //    Obtenemos la posición actual de la sección respecto al viewport
      const elementPosition = element.getBoundingClientRect().top;

      //    Calculamos la posición final: posición actual + posición de scroll actual - offset
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      // 3. Aplicar el scroll a la nueva posición calculada
      window.scrollTo({
        top: offsetPosition,
        // Importante: Usar 'auto' para evitar que este scroll
        // active la lógica de tu hook useScrollDirection.
        behavior: "auto",
      });
    }
  };

  const navigateTo = {
    inicio: () => navigate("/"),
    conflo: () => navigate("/Conflo"),
    rojokaram: () => navigate("/Rojokam"),
    rikpak: () => navigate("/Rikpak"),
    sienepmc: () => navigate("/Sienepmc"),
    siendci: () => navigate("/Siendci"),
  };

  return (
    <header
      //  bg-gradient-to-b from-black/50
      className={`
        w-full fixed top-0 left-0 z-50 
       bg-[#00003b] shadow-md 
        transition-transform duration-300 ease-in-out
        ${isHidden ? "-translate-y-full" : "translate-y-0"}
      `}
    >
      <div className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between py-2">
          {/* Lado izquierdo: Logo + Texto */}
          <div className="flex items-center gap-3">
            <div className="cursor-pointer" onClick={navigateTo.inicio}>
              <img
                src={logocompleto}
                alt="logo Fomex"
                className="w-40 h-20 cursor-pointer"
              />
            </div>

            {/* <div className="text-left">
              <div className="text-xl font-bold text-white">FOMEX</div>
              <div className="text-sm text-white opacity-80">
                Grupo empresarial
              </div>
            </div> */}
          </div>

          {/* Centro: Enlaces de Navegación (OCULTO en móvil, ahora visible solo desde 'lg') */}
          <nav className="hidden lg:flex space-x-8 text-lg items-center absolute left-1/2 transform -translate-x-1/2">
            <a
              onClick={() => scrollToSection("inicio")}
              className="text-white hover:text-gray-300 transition cursor-pointer"
            >
              Inicio
            </a>
            <a
              onClick={() => scrollToSection("about")}
              className="text-white hover:text-gray-300 transition cursor-pointer"
            >
              Grupo
            </a>
            <a
              onClick={() => scrollToSection("empresas")}
              className="text-white hover:text-gray-300 transition cursor-pointer"
            >
              Empresas
            </a>
            <a
              onClick={() => scrollToSection("servicios")}
              className="text-white hover:text-gray-300 transition cursor-pointer"
            >
              Servicios
            </a>
            <a
              onClick={() => scrollToSection("proyectos")}
              className="text-white hover:text-gray-300 transition cursor-pointer"
            >
              Proyectos
            </a>
            <a
              onClick={() => scrollToSection("contacto")}
              className="text-white hover:text-gray-300 transition cursor-pointer"
            >
              Contacto
            </a>
          </nav>

          {/* Redes Sociales */}
          <nav>
            <div className="flex space-x-5 text-white">
              <a
                href="https://wa.me/5216681502496?text=Hola%2C%20quiero%20mas%20informacion"
                className="hover:text-blue-400 transition"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icons.Whatsapp className="w-6 h-6" />  
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61582577164747"
                className="hover:text-blue-400 transition"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  className="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 2C6.477 2 2 6.477 2 12c0 5.174 3.784 9.444 8.706 10.155V15.5H8.381V12H11.08V9.309c0-2.673 1.624-4.136 4.02-4.136 1.144 0 2.13.204 2.417.295V7.5H15.69c-1.353 0-1.615.642-1.615 1.58V12h2.932l-.468 3.5h-2.464V22.155C18.216 21.444 22 17.174 22 12c0-5.523-4.477-10-10-10z" />
                </svg>
              </a>

              <a
                href="https://www.instagram.com/grupo_fomex/ "
                className="hover:text-blue-400 transition"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icons.Instagram className="w-6 h-6" />
              </a>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
